import { Node, NodeProps } from '@xyflow/react';
import { useAtomValue } from 'jotai';
import { FC, memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { IconSvg } from '@/lib/v2/components';
import { CommonFlowCard, CommonFlowCardProps } from '@/lib/v3/components';

import { atomIntegrationsOptions } from '@/src/modules/AutomationModuleNew/atoms/flows';
import { TRANSLATIONS } from '@/src/modules/AutomationModuleNew/constants/flows';
import { useHandleSidePanel } from '@/src/modules/AutomationModuleNew/hooks/Flows/useHandleSidePanel';
import { TriggerNodeData } from '@/src/modules/AutomationModuleNew/types/flowsTypes';

import { TriggerIcon } from '@/modules/AutomationModuleNew/icons';

type TriggerNodeProps = NodeProps<Node<TriggerNodeData>>;

const TriggerNode: FC<TriggerNodeProps> = (props) => {
  const { t } = useTranslation();
  const { data } = props;
  const { handleOpenSidePanel } = useHandleSidePanel();
  const integrationsOptions = useAtomValue(atomIntegrationsOptions);

  const { icon, title, info, borderColor, id } = useMemo<CommonFlowCardProps>(() => {
    switch (data.type) {
      case 'integration': {
        const integrationId = data.triggerId;
        const integrationName = integrationsOptions.find(
          (integration) => integration.value === integrationId
        )?.name;

        const info = integrationId ? integrationName ?? data.triggerContent?.name : undefined;

        return {
          id: data.id,
          icon: (
            <IconSvg
              fillColor="success"
              height="100%"
              svgComponent={<TriggerIcon />}
              width="100%"
            />
          ),
          title: t(TRANSLATIONS.nodeTypes.integration),
          info,
          borderColor: 'trigger',
        };
      }
    }
  }, [data, integrationsOptions, t]);

  return (
    <CommonFlowCard
      noTargetHandle
      borderColor={borderColor}
      editAction={{ label: t('TriggerNode.edit'), onClick: handleOpenSidePanel }}
      icon={icon}
      id={id}
      info={info}
      title={title}
    />
  );
};

export default memo(TriggerNode);
